import { useTranslation } from 'react-i18next';

export const NumberComponent = ({
  totalNumber,
  size = 'text-3xl',
}: {
  totalNumber: number;
  size?: string;
}) => {
  const [t] = useTranslation('consumer_stats');
  let displayNumber = totalNumber;
  let suffix = '';

  if (Math.abs(totalNumber) >= 1_000_000_000) {
    displayNumber = totalNumber / 1_000_000_000;
    suffix = t('billion', 'B');
  } else if (Math.abs(totalNumber) >= 1_000_000) {
    displayNumber = totalNumber / 1_000_000;
    suffix = t('million', 'M');
  } else if (Math.abs(totalNumber) >= 10_000) {
    displayNumber = totalNumber / 1_000;
    suffix = t('thousand', 'K');
  }

  // Format to max 3 significant digits, up to 5 chars with suffix
  let formatted = '';
  if (suffix) {
    formatted = displayNumber.toLocaleString('es-CO', {
      maximumSignificantDigits: 3,
      maximumFractionDigits: 2,
    });
    // Remove trailing .0 or .00
    formatted = formatted.replace(/\.?0+$/, '');
    // Ensure max 5 chars (number + suffix)
    if ((formatted + suffix).length > 5) {
      formatted = displayNumber.toFixed(2).replace(/\.?0+$/, '');
      if ((formatted + suffix).length > 5) {
        formatted = displayNumber.toFixed(1).replace(/\.?0+$/, '');
      }
      if ((formatted + suffix).length > 5) {
        formatted = Math.round(displayNumber).toString();
      }
    }
  } else {
    formatted = displayNumber.toLocaleString('es-CO', {
      maximumFractionDigits: 0,
    });
    if (formatted.length > 5) {
      formatted = formatted.slice(0, 5);
    }
  }

  return (
    <div className="flex items-center">
      <p className={`${size} font-semibold`}>{formatted}</p>
      {suffix && <p className={`${size} ml-1`}>{suffix}</p>}
    </div>
  );
};
